import { ConvertToSubscriptionValidationTooltip } from 'commerce-subscription-lib/public/convertToSubscription';
import get from 'hs-lodash/get';
import { QUOTE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { getQuoteId, isImmutableQuote } from '../utils/quote';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import QuotesLogger from '../tracking/quotesLogger';
import { hasAtLeastOneRecurring } from 'products-ui-components/utils/recurrence';
import { getLineItem } from 'products-ui-components/utils/subject';
import { QUOTE_ASSOCIATIONS } from 'customer-data-objects/quote/constants/properties';
import { List } from 'immutable';
import { useEffect, useState } from 'react';
import { getBillingWizardURL } from 'commerce-subscription-lib/public/billingWizard';
import { getIsArchived, getIsPublished } from '../utils/status';
import { getAssociatedLineItems } from '../api/CrmSearchApi';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
function getQuoteLineItems(quote) {
  if (isImmutableQuote(quote)) {
    const lineItems = quote.getIn(['quote', 'associatedObjects', QUOTE_ASSOCIATIONS.QUOTE_TO_LINE_ITEM]) || quote.quoteAssociatedObjects.lineItems || List([]);
    return lineItems.map(getLineItem).toJS();
  }
  return get(quote, ['quote', 'associatedObjects', QUOTE_ASSOCIATIONS.QUOTE_TO_LINE_ITEM]) || quote.quoteAssociatedObjects.lineItems || [];
}
export function quoteHasRecurringLineItems(quote) {
  return hasAtLeastOneRecurring(getQuoteLineItems(quote));
}
export function useIsConvertableToSubscription({
  quote,
  isActionsDropdownOpen,
  isScopedForSubscription,
  portalId
}) {
  const rawId = getQuoteId(quote);
  const objectId = typeof rawId === 'number' ? rawId : parseInt(rawId !== null && rawId !== void 0 ? rawId : '-1', 10);
  const hasValidId = rawId && objectId !== -1;
  const [hasRecurringLineItems, setHasRecurringLineItems] = useState(false);
  useEffect(() => {
    if (!hasValidId || !isActionsDropdownOpen || getIsArchived(quote) || !getIsPublished(quote) || !isScopedForSubscription || !portalId || hasRecurringLineItems) {
      return;
    }
    if (quoteHasRecurringLineItems(quote)) {
      setHasRecurringLineItems(true);
      return;
    }
    if (getQuoteLineItems(quote).length > 0) {
      return;
    }
    getAssociatedLineItems(objectId, portalId).then(lineItems => {
      setHasRecurringLineItems(lineItems.some(lineItem => {
        var _lineItem$properties;
        return lineItem === null || lineItem === void 0 || (_lineItem$properties = lineItem.properties) === null || _lineItem$properties === void 0 || (_lineItem$properties = _lineItem$properties.recurringbillingfrequency) === null || _lineItem$properties === void 0 ? void 0 : _lineItem$properties.value;
      }));
    }).catch(e => {
      Raven.captureException(e, {
        stacktrace: true
      });
    });
  }, [hasValidId, isActionsDropdownOpen, isScopedForSubscription, portalId, hasRecurringLineItems, quote, objectId]);
  return hasRecurringLineItems;
}
function ConvertToSubscriptionButtonWrapper({
  quote,
  portalId
}) {
  const rawId = getQuoteId(quote);
  if (!quote || !rawId || !portalId) {
    return null;
  }
  const objectId = typeof rawId === 'number' ? rawId : parseInt(rawId, 10);
  return /*#__PURE__*/_jsx(ConvertToSubscriptionValidationTooltip, {
    objectId: objectId,
    objectTypeId: QUOTE_TYPE_ID,
    renderButton: ({
      disabled,
      loading
    }) => {
      return /*#__PURE__*/_jsx(Button, {
        "data-test-id": "commerce-quote:convert-to-subscription-button",
        disabled: disabled || loading,
        onClick: () => {
          QuotesLogger.log('quoteInteraction', {
            // if changed, update quoteInteraction properties in quoteInteractionEvents.yaml
            action: 'Click convert to billing'
          });
          window.location.href = getBillingWizardURL({
            portalId,
            fromObjectId: objectId,
            fromObjectTypeId: QUOTE_TYPE_ID
          });
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.ConvertToSubscription.buttonLabels.convertQuote"
        })
      });
    }
  });
}
export default ConvertToSubscriptionButtonWrapper;